import type { SessionTutorialTipProps } from '@/features/session-tutorial/sessionTutorial.types';
import { sessionTutorialNav } from '@/features/session-tutorial/sessionTutorialContent';
import { SESSION_TUTORIAL_UI_ATTRIBUTE } from '@/features/session-tutorial/useInertOutside';
import { Button, PopoverContent, Stack, Text } from '@careflux/primitives';
import { useId } from 'react';

export const SessionTutorialTip = ({
  copy,
  stepNumber,
  totalSteps,
  canAdvance,
  onNext,
  onSkip,
}: SessionTutorialTipProps) => {
  const titleId = useId();
  const isLastStep = stepNumber === totalSteps;

  return (
    <PopoverContent
      aria-labelledby={titleId}
      {...{ [SESSION_TUTORIAL_UI_ATTRIBUTE]: '' }}
      // Never pull focus out of the page (e.g. the dictation editor) when a tip (re)appears.
      onOpenAutoFocus={(event) => event.preventDefault()}
      // Session pages keep CSS-hidden copies of their controls: hide rather than float at 0,0.
      hideWhenDetached
      // Clicks elsewhere still reach the page (the tip is non-modal) but never close it.
      onInteractOutside={(event) => event.preventDefault()}
      onEscapeKeyDown={onSkip}
    >
      <Stack gap="sm">
        <Text id={titleId} weight="semibold">
          {copy.title}
        </Text>
        <Text size="sm" color="muted">
          {copy.body}
        </Text>
        <Stack direction="horizontal" justify="between" align="center">
          <Text size="xs" color="muted">
            {sessionTutorialNav.progress(stepNumber, totalSteps)}
          </Text>
          <Stack direction="horizontal" gap="xs">
            {!isLastStep && (
              <Button variant="ghost" size="sm" onClick={onSkip}>
                {sessionTutorialNav.skip}
              </Button>
            )}
            {canAdvance && (
              <Button size="sm" onClick={onNext}>
                {isLastStep ? sessionTutorialNav.done : sessionTutorialNav.next}
              </Button>
            )}
          </Stack>
        </Stack>
      </Stack>
    </PopoverContent>
  );
};
